"use client";

import { useState, useRef } from "react";
import VideoModal from "@/components/VideoModal/VideoModal";

import Avatar from "../images/happy-customers/sri-vatsan.png";
import Picture from "../images/happy-customers/malaysia-review-img-1.jpg";
import Review from "../images/happy-customers/google-review.svg";

import Avatar1 from "../images/happy-customers/srinivas.png";
import Picture1 from "../images/happy-customers/malaysia-review-img-2.jpg";

import Avatar2 from "../images/happy-customers/archana.png";
import Picture2 from "../images/happy-customers/malaysia-review-img-3.jpg";

import Avatar3 from "../images/happy-customers/ram.png";
import Picture3 from "../images/happy-customers/malaysia-review-img-4.jpg";

import Avatar4 from "../images/happy-customers/thagu.png";
import Picture4 from "../images/happy-customers/malaysia-review-img-5.jpg";

import Avatar5 from "../images/happy-customers/punitha.png";
import Picture5 from "../images/happy-customers/bachelor-review-img-1.jpg";
import Picture6 from "../images/happy-customers/honeymoon-review-img-2.jpg";

import "@/styles/common/customer-reviews.scss";
import "@/sections/common/happy-customers/happy-customers.scss";
import "@/styles/common/typo.scss";

import Button from "@/components/button/Button";
import Heading from "@/components/heading/heading";

import Image from "next/image";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const REVIEWS1 = [
    {
        id: 1,
        name: "Srinivasan Muthiah",
        review: "Very Good Tour Agency. Friendly Co Ordination and Excellent Support 24x7. I thank Dimaak Tours and their team. You guys are just Awesome! Keep Rocking!",
        image: Avatar,
    },
    {
        id: 2,
        showImage: true,
        image: Picture,
    },
    {
        id: 3,
        name: "Sri",
        review: "Dimaak tours is very authentic and they are doing good job.👍Everything from pickup, drop, place to visit arrangements and hotel stay all good 🤗thanks. I would prefer dimaak tours next time.thank you.",
        image: Avatar1,
    },
    {
        id: 4,
        showImage: true,
        image: Picture1,
        thumbnail: Picture5,
        videoId: "1ipT8bG2RjI",
        videoTitle: "Family",
    },

    {
        id: 5,
        name: "Archana",
        review: "Thank you for providing me the best package. Great services. It was a memorable trip. Great coordination. Would refer it to all my family and friends.",
        image: Avatar2,
    },
    {
        id: 6,
        showImage: true,
        image: Picture2,
    },
];
const REVIEWS2 = [
    {
        id: 7,
        name: "Ram Chandh",
        review: "Hello Raj, I wanted to express my gratitude for your excellent and smooth support during the trip. Your assurance, if you face any issues, let me know, I will take care from here, was truly uplifting for someone away from their home country. Once again, thank you immensely for your invaluable support.",
        image: Avatar3,
    },
    {
        id: 8,
        showImage: true,
        image: Picture2,
        thumbnail: Picture6,
        videoId: "A37vot7oG9Y",
        videoTitle: "Honeymoon",
    },
    {
        id: 9,
        name: "S Thyagu",
        review: "Dear Dimaak Team, It was a great fun and pleasure trip with you guys. It was well planned and organised.especially the organiser Anirudh was very helpful and easy to access for al kind of help and information.Great job dimaak.",
        image: Avatar4,
    },
    {
        id: 10,
        showImage: true,
        image: Picture3,
    },

    {
        id: 11,
        name: "Punitha Ubendiran",
        review: "Best Trip, The Process Was Super Smooth, Thanks To Muthu & Anirudh, You Guys Where Awesome, Will come back again & again to u guys with my list of places to visit 💖.",
        image: Avatar5,
    },
    {
        id: 12,
        showImage: true,
        image: Picture4,
    },
];

const HappyCustomers = () => {
    const [modalStates, setModalStates] = useState(REVIEWS1.map(() => false));
    const [modal2States, setModal2States] = useState(REVIEWS2.map(() => false));
    const swiperRef1 = useRef<any>(null);
    const swiperRef2 = useRef<any>(null);

    const handleEnter = () => {
        swiperRef1.current.swiper.autoplay.stop();
        swiperRef2.current.swiper.autoplay.stop();
    };

    const handleLeave = () => {
        swiperRef1.current.swiper.autoplay.start();
        swiperRef2.current.swiper.autoplay.start();
    };

    const openModal = (index: number, reviewsListNo: number) => {
        if (reviewsListNo === 1) {
            const newModalStates = [...modalStates];
            newModalStates[index] = true;
            setModalStates(newModalStates);
        } else {
            const newModalStates = [...modal2States];
            newModalStates[index] = true;
            setModal2States(newModalStates);
        }
    };

    const closeModal = (index: number, reviewsListNo: number) => {
        if (reviewsListNo === 1) {
            const newModalStates = [...modalStates];
            newModalStates[index] = false;
            setModalStates(newModalStates);
        } else {
            const newModalStates = [...modal2States];
            newModalStates[index] = false;
            setModal2States(newModalStates);
        }
    };

    return (
        <section className="happy-customers-section">
            <div className="container px-4 mx-auto flex flex-col gap-6 sm:gap-14">
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
                    <div className="happy-customers-block col-span-1 flex flex-col justify-center items-start gap-3 sm:gap-6 lg:col-span-1">
                        <small className="font-yesteryear font-extralight">
                            Our Customers Love
                        </small>
                        <Heading as="h2">Travel Experiences</Heading>
                        <p className="lead">
                            Discover what our valued customers have to say about
                            their unforgettable experiences. Read genuine
                            reviews and testimonials showcasing the joy and
                            satisfaction of their journeys with us
                        </p>
                        <div className="button-review flex flex-wrap items-center gap-x-6 gap-y-1">
                            <Button
                                onClick={() =>
                                    window.open("/reviews/malaysia", "_self")
                                }
                                className="flex items-center"
                                variant="orange"
                            >
                                <span>View more Reviews</span>
                            </Button>
                            <Image
                                loading="lazy"
                                src={Review}
                                alt="Review"
                                className="review"
                            />
                            <div className="star-reviews flex items-center gap-1">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15.4829 5.63406L10.6864 4.90408L8.54222 0.352135C8.48365 0.227506 8.38731 0.126615 8.26829 0.0652895C7.96981 -0.0890138 7.6071 0.0395723 7.45786 0.352135L5.3137 4.90408L0.517213 5.63406C0.384974 5.65384 0.26407 5.71912 0.171503 5.81803C0.0595945 5.93848 -0.0020722 6.10053 5.31712e-05 6.26856C0.00217854 6.4366 0.0679221 6.59688 0.182838 6.71418L3.65316 10.2572L2.83328 15.2602C2.81405 15.3766 2.82635 15.4963 2.86878 15.6057C2.91121 15.7151 2.98207 15.8099 3.07333 15.8793C3.16459 15.9488 3.27259 15.99 3.38509 15.9984C3.4976 16.0068 3.6101 15.982 3.70983 15.9269L8.00004 13.5648L12.2902 15.9269C12.4074 15.9922 12.5434 16.0139 12.6737 15.9902C13.0024 15.9308 13.2235 15.6044 13.1668 15.2602L12.3469 10.2572L15.8172 6.71418C15.9117 6.61724 15.974 6.49064 15.9929 6.35216C16.0439 6.00597 15.8135 5.68549 15.4829 5.63406Z"
                                        fill="#FF4514"
                                    ></path>
                                </svg>{" "}
                                <span>4.9 (75 Reviews)</span>
                            </div>
                        </div>
                    </div>
                    <div className="happy-customers-slider happy-customers-slider-vertical col-span-1 flex-col gap-4 lg:col-span-2 hidden lg:flex">
                        <div
                            className="grid-cols-1 gap-6 lg:grid-cols-2 grid"
                            onMouseEnter={handleEnter}
                            onMouseLeave={handleLeave}
                        >
                            <div className="happy-customers-slider-one happy-customers-slider col-span-1 flex flex-col gap-4 lg:col-span-1">
                                <Swiper
                                    ref={swiperRef1}
                                    slidesPerView={1.5}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    direction="vertical"
                                    speed={3000}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                        waitForTransition: true,
                                        pauseOnMouseEnter: true,
                                    }}
                                    loop={true}
                                    className="swiper-container"
                                    autoHeight={true}
                                    height={400}
                                >
                                    {REVIEWS1?.map((review, index) => (
                                        <SwiperSlide
                                            key={review.id}
                                            className={`swiper-slide ${
                                                review.showImage
                                                    ? "with-image-h"
                                                    : "without-image-h"
                                            }`}
                                            style={{
                                                height: "100% !important",
                                                color: "red",
                                            }}
                                        >
                                            {review.showImage ? (
                                                <div className="with-image h-full">
                                                    {review.videoId ? (
                                                        <div
                                                            className="picture object-fill h-full"
                                                            onClick={() =>
                                                                openModal(
                                                                    index,
                                                                    1
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <Image
                                                                loading="lazy"
                                                                src={
                                                                    review.thumbnail
                                                                }
                                                                alt="Picture"
                                                                className="picture object-fill h-full"
                                                            />
                                                            <div
                                                                className="play-button"
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <svg
                                                                    width="61"
                                                                    height="61"
                                                                    viewBox="0 0 61 61"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="30.5"
                                                                        cy="30.5"
                                                                        r="30.5"
                                                                        fill="#FFF3ED"
                                                                    />
                                                                    <path
                                                                        d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                        fill="#FF4514"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Picture"
                                                            className="picture object-fill h-full"
                                                        />
                                                    )}

                                                    <VideoModal
                                                        videoTitle={
                                                            review.videoTitle
                                                        }
                                                        videoId={review.videoId}
                                                        isOpen={
                                                            modalStates[index]
                                                        }
                                                        onClose={() => {
                                                            closeModal(
                                                                index,
                                                                1
                                                            );
                                                            swiperRef1.current.swiper.autoplay.start();
                                                            swiperRef2.current.swiper.autoplay.start();
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                                    <p className="lead">
                                                        {review.review}
                                                    </p>
                                                    <div className="avatar flex items-center mt-auto gap-3">
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Avatar"
                                                            className="avatar"
                                                        />
                                                        <span className="font-semibold">
                                                            {review.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            <div className="happy-customers-slider-two happy-customers-slider col-span-1 flex flex-col gap-4 lg:col-span-1">
                                <Swiper
                                    ref={swiperRef2}
                                    slidesPerView={1.5}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    direction="vertical"
                                    speed={3000}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                        waitForTransition: true,
                                        pauseOnMouseEnter: true,
                                        reverseDirection: true,
                                    }}
                                    loop={true}
                                    className="swiper-container"
                                    onSlideChange={(e) => {}}
                                    onSwiper={(swiper) => {}}
                                    autoHeight={true}
                                    height={400}
                                >
                                    {REVIEWS2?.map((review, index) => (
                                        <SwiperSlide
                                            key={review.id}
                                            className={`swiper-slide ${
                                                review.showImage
                                                    ? "with-image-h"
                                                    : "without-image-h"
                                            }`}
                                            style={{
                                                height: "100% !important",
                                                color: "red",
                                            }}
                                        >
                                            {review.showImage ? (
                                                <div className="with-image h-full">
                                                    {review.videoId ? (
                                                        <div
                                                            className="picture object-fill h-full"
                                                            onClick={() =>
                                                                openModal(
                                                                    index,
                                                                    2
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <Image
                                                                loading="lazy"
                                                                src={
                                                                    review.thumbnail
                                                                }
                                                                alt="Picture"
                                                                className="picture object-fill h-full"
                                                            />
                                                            <div
                                                                className="play-button"
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <svg
                                                                    width="61"
                                                                    height="61"
                                                                    viewBox="0 0 61 61"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="30.5"
                                                                        cy="30.5"
                                                                        r="30.5"
                                                                        fill="#FFF3ED"
                                                                    />
                                                                    <path
                                                                        d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                        fill="#FF4514"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Picture"
                                                            className="picture object-fill h-full"
                                                        />
                                                    )}

                                                    <VideoModal
                                                        videoTitle={
                                                            review.videoTitle
                                                        }
                                                        videoId={review.videoId}
                                                        isOpen={
                                                            modal2States[index]
                                                        }
                                                        onClose={() => {
                                                            closeModal(
                                                                index,
                                                                2
                                                            );
                                                            swiperRef1.current.swiper.autoplay.start();
                                                            swiperRef2.current.swiper.autoplay.start();
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                                    <p className="lead">
                                                        {review.review}
                                                    </p>
                                                    <div className="avatar flex items-center mt-auto gap-3">
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Avatar"
                                                            className="avatar"
                                                        />
                                                        <span className="font-semibold">
                                                            {review.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <div className="happy-customers-slider happy-customers-slider-horizontal col-span-1 flex flex-col gap-4 lg:col-span-1 mt-4 h-32">
                        <Swiper
                            slidesPerView={1.5}
                            spaceBetween={30}
                            centeredSlides={true}
                            direction="horizontal"
                            speed={3000}
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 1,
                                disableOnInteraction: false,
                                waitForTransition: true,
                                pauseOnMouseEnter: true,
                            }}
                            loop={true}
                            className="swiper-container"
                            autoHeight={false}
                            height={100}
                        >
                            {REVIEWS1?.map((review, index) => (
                                <SwiperSlide
                                    key={review.id}
                                    className={`swiper-slide ${
                                        review.showImage
                                            ? "with-image-h"
                                            : "without-image-h"
                                    }`}
                                    style={{
                                        height: "100% !important",
                                        color: "red",
                                    }}
                                >
                                    {review.showImage ? (
                                        <div className="with-image h-full">
                                            {review.videoId ? (
                                                <div
                                                    className="picture object-fill h-full"
                                                    onClick={() =>
                                                        openModal(index, 1)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Image
                                                        loading="lazy"
                                                        src={review.thumbnail}
                                                        alt="Picture"
                                                        className="picture object-fill h-full"
                                                    />
                                                    <div
                                                        className="play-button"
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform:
                                                                "translate(-50%, -50%)",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <svg
                                                            width="61"
                                                            height="61"
                                                            viewBox="0 0 61 61"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="30.5"
                                                                cy="30.5"
                                                                r="30.5"
                                                                fill="#FFF3ED"
                                                            />
                                                            <path
                                                                d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                fill="#FF4514"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Picture"
                                                    className="picture object-fill h-full"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                            <p className="lead">
                                                {review.review}
                                            </p>
                                            <div className="avatar flex items-center mt-auto gap-3">
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Avatar"
                                                    className="avatar"
                                                />
                                                <span className="font-semibold">
                                                    {review.name}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                            {REVIEWS2?.map((review, index) => (
                                <SwiperSlide
                                    key={review.id}
                                    className={`swiper-slide ${
                                        review.showImage
                                            ? "with-image-h"
                                            : "without-image-h"
                                    }`}
                                    style={{
                                        height: "100% !important",
                                        color: "red",
                                    }}
                                >
                                    {review.showImage ? (
                                        <div className="with-image h-full">
                                            {review.videoId ? (
                                                <div
                                                    className="picture object-fill h-full"
                                                    onClick={() =>
                                                        openModal(index, 2)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Image
                                                        loading="lazy"
                                                        src={review.thumbnail}
                                                        alt="Picture"
                                                        className="picture object-fill h-full"
                                                    />
                                                    <div
                                                        className="play-button"
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform:
                                                                "translate(-50%, -50%)",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <svg
                                                            width="61"
                                                            height="61"
                                                            viewBox="0 0 61 61"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="30.5"
                                                                cy="30.5"
                                                                r="30.5"
                                                                fill="#FFF3ED"
                                                            />
                                                            <path
                                                                d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                fill="#FF4514"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Picture"
                                                    className="picture object-fill h-full"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                            <p className="lead">
                                                {review.review}
                                            </p>
                                            <div className="avatar flex items-center mt-auto gap-3">
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Avatar"
                                                    className="avatar"
                                                />
                                                <span className="font-semibold">
                                                    {review.name}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HappyCustomers;
